// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q3WtU","delete":"styles_delete__3grAt","update":"styles_update__3KYNg","add":"styles_add__3__2p"};